
webpack.register(
    'components/brightcove-video/brightcove-video',
    function() {
        return require('components/brightcove-video/brightcove-video');
    },
    false
);
webpack.register(
    'components/live-brightcove-video/live-brightcove-video',
    function() {
        return require('components/live-brightcove-video/live-brightcove-video');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/brightcove-video/brightcove-video'/>\r\n<can-import from='components/live-brightcove-video/live-brightcove-video'/>\r\n\r\n{{#if playerId}}\r\n    <live-brightcove-video\r\n        scroll=\"true\"\r\n        is-active=\"true\"\r\n        {player-id}=\"playerId\"\r\n        {video-id}=\"videoId\"\r\n        {image}=\"image\"\r\n        {autoplay}=\"autoplay\"\r\n    >\r\n    </live-brightcove-video>\r\n{{else}}\r\n    <brightcove-video {autoplay}=\"autoplay\" {video-id}=\"videoId\" {muted}=\"muted\"/>\r\n{{/if}}\r\n");